// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwSplmTable from 'viewmodel/AwSplmTableViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "lifecycleHooks": {
        "onUpdate": [
            {
                "action": "reveal",
                "observers": [
                    "props.catalogid"
                ]
            }
        ]
    },
    "data": {
        "loadColumn": [
            {
                "name": "actionDate",
                "displayName": "{{i18n.actionDate}}",
                "maxWidth": 280,
                "minWidth": 180,
                "width": 180,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "role",
                "displayName": "{{i18n.role}}",
                "maxWidth": 280,
                "minWidth": 180,
                "width": 180,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "action",
                "displayName": "{{i18n.action}}",
                "maxWidth": 280,
                "minWidth": 180,
                "width": 180,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            },
            {
                "name": "remark",
                "displayName": "{{i18n.remark}}",
                "maxWidth": 400,
                "minWidth": 200,
                "width": 500,
                "enableColumnMenu": false,
                "enableColumnHiding": false,
                "pinnedLeft": true
            }
        ]
    },
    "props": {
        "accsessionid": {
            "type": "STRING"
        },
        "catalogspaceid": {
            "type": "STRING"
        },
        "provider": {
            "type": "STRING"
        },
        "catalogid": {
            "type": "STRING"
        },
        "locale": {
            "type": "STRING"
        }
    },
    "dataProviders": {
        "catalogLogsTableRowProvider": {
            "action": "getStatusLogsOfSelectedCatalog",
            "response": "{{data.catalogLogs}}",
            "totalFound": "{{data.catalogLogs.length}}",
            "selectionModelMode": "single"
        }
    },
    "columnProviders": {
        "catalogLogsTableColumnProvider": {
            "frozenColumnIndex": -1,
            "columns": "{{data.loadColumn}}"
        }
    },
    "grids": {
        "catalogLogsTable": {
            "dataProvider": "catalogLogsTableRowProvider",
            "columnProvider": "catalogLogsTableColumnProvider",
            "addIconColumn": false,
            "gridOptions": {
                "enablePinning": true,
                "enableSorting": false,
                "enableDynamicRowHeight": true
            }
        }
    },
    "actions": {
        "getStatusLogsOfSelectedCatalog": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": false,
                    "data": {
                        "additionalProperties": {
                            "catalogspaceId": "{{props.catalogspaceid}}"
                        },
                        "appBaseUrl": "session",
                        "query": "query getStatusLogs( $getStatusLogsInput: GetStatusLogsInput) { getStatusLogs( getStatusLogsInput: $getStatusLogsInput ) }",
                        "variables": {
                            "getStatusLogsInput": {
                                "id": "{{props.catalogid}}",
                                "provider": "{{props.provider}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}"
            },
            "outputData": {
                "catalogLogs": "data.data.getStatusLogs.output.data"
            },
            "events": {
                "success": [
                    {
                        "name": "getStatusLogsOfCatalog.success",
                        "eventData": {
                            "catalogLogs": "{{data.output.data}}"
                        },
                        "condition": "output.success == true"
                    }
                ],
                "failure": [
                    {
                        "name": "getStatusLogsOfCatalog.failure",
                        "eventData": {
                            "catalogLogs": "{{data.output}}"
                        },
                        "condition": "output.success == false"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "reveal": {
            "actionType": "dataProvider",
            "method": "catalogLogsTableRowProvider"
        }
    },
    "onEvent": [],
    "conditions": {},
    "i18n": {
        "actionDate": [
            "DesCatalogStatusLogsmessages"
        ],
        "role": [
            "DesCatalogStatusLogsmessages"
        ],
        "remark": [
            "DesCatalogStatusLogsmessages"
        ],
        "action": [
            "DesCatalogStatusLogsmessages"
        ]
    },
    "_viewModelId": "DesCatalogStatusLogs",
    "_uniqueViewModelId": "DesCatalogStatusLogs",
    "ctx": {}
};

    /*
    <aw-panel>
    <aw-panel-body>
        <aw-splm-table gridid="catalogLogsTable"></aw-splm-table>
    </aw-panel-body>
</aw-panel>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <AwPanelBody>
            <AwSplmTable {...grids.catalogLogsTable}>
            </AwSplmTable>
        </AwPanelBody>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;